import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StartComponent } from "./start/start.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "../services/authgaurd.service";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { onlyFirstWordPipe } from "../shared/pipe/onlyFirstWordCapital.pipe";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { RegisterComponent } from "./sidenav/register/register.component";
import { CartlengthService } from "../services/cartlength.service";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SharedModule } from "../shared/shared.module";
import { AddCreditCardComponent } from "./sidenav/add-credit-card/add-credit-card.component";
import { NgxFastMarqueeModule } from 'ngx-fast-marquee';
import { NotFoundComponent } from "./not-found/not-found.component";
import { CannabisDispensaryInLarchmontComponent } from "../pages/SEO-pages/Cannabis-Dispensary-in-Larchmont/cannabis-dispensary-in-larchmont.component";
import { VapeStoreInLarchmontComponent } from "../pages/SEO-pages/Vape-Store-in-Larchmont/vape-store-in-larchmont.component";
import { BuyWeedOnlineInRyeComponent } from "../pages/SEO-pages/Buy-Weed-Online-in-Rye/buy-weed-online-in-rye.component";
import { BuyEdiblesOnlinePoundRidgeComponent } from "../pages/SEO-pages/Buy-Edibles-Online-Pound-Ridge/buy-edibles-online-pound-ridge.component";
import { ProductListingComponent } from "../pages/SEO-pages/product-listing/product-listing.component";
import { CannabisDispensaryDeliveryMamaroneckComponent } from "../pages/SEO-pages/cannabis-dispensary-delivery-mamaroneck/cannabis-dispensary-delivery-mamaroneck.component";
import { BuyPreRollsOnlineRyeComponent } from "../pages/SEO-pages/buy-pre-rolls-online-rye/buy-pre-rolls-online-rye.component";
import { BestVapeDeliveryServiceMamaroneckNYComponent } from "../pages/SEO-pages/best-vape-delivery-service-mamaroneck-ny/best-vape-delivery-service-mamaroneck-ny.component";
import { CannabisDispensaryDeliveryBronxComponent } from "../pages/SEO-pages/cannabis-dispensary-delivery-bronx/cannabis-dispensary-delivery-bronx.component";
import { OnlineWeedDispensaryBronxComponent } from "../pages/SEO-pages/online-weed-dispensary-bronx/online-weed-dispensary-bronx.component";
import { WeedDispensaryMamaroneckComponent } from "../pages/SEO-pages/weed-dispensary-mamaroneck/weed-dispensary-mamaroneck.component";
import { THCDrinksInBronxComponent } from "../pages/SEO-pages/thc-drinks-in-bronx/thc-drinks-in-bronx.component";
import { VapePenCartridgesShopOnlineInBronxComponent } from "../pages/SEO-pages/vape-pen-cartridges-shop-online-in-bronx/vape-pen-cartridges-shop-online-in-bronx.component";

const routes: Routes = [
  {
    path: "",
    component: StartComponent,
    // canActivate:[AgeGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("../pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "about-us",
        loadChildren: () =>
          import("../pages/about-us/about-us.module").then(
            (m) => m.AboutUsModule
          ),
      },

      {
        path: "app",
        loadChildren: () =>
          import("../pages/Live-App/live-app.modules").then(
            (m) => m.LiveAppModule
          ),
      },

      {
        path: "faq",
        loadChildren: () =>
          import("../pages/faq/faq.module").then((m) => m.FaqModule),
      },
      {
        path: "how-to-order",
        loadChildren: () =>
          import("../pages/howtoorder/howtoorder.module").then(
            (m) => m.HowtoorderModule
          ),
      },
      {
        path: "contact-us",
        loadChildren: () =>
          import("../pages/contact-us/contact-us.module").then(
            (m) => m.ContactUsModule
          ),
      },

      {
        path: "return-exchange",
        loadChildren: () =>
          import("../pages/return-exchange/return-exchange.module").then(
            (m) => m.ReturnExchangeModule
          ),
      },
      {
        path: "termsandcondition",
        loadChildren: () =>
          import("../pages/termsandcondition/termsandcondition.module").then(
            (m) => m.TermsandconditionModule
          ),
      },
      {
        path: "privacypolicy",
        loadChildren: () =>
          import("../pages/privacypolicy/privacypolicy.module").then(
            (m) => m.PrivacypolicyModule
          ),
      },
      {
        path: "login",
        loadChildren: () =>
          import("../pages/login/login.module").then((m) => m.LoginModule),
      },
      {
        path: "register",
        loadChildren: () =>
          import("../pages/register/register.module").then(
            (m) => m.RegisterModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "mobile-verify",
        loadChildren: () =>
          import("../pages/mobile-verify/mobile-verify.module").then(
            (m) => m.MobileVerifyModule
          ),
      },
      {
        path: "upload-id",
        loadChildren: () =>
          import("../pages/upload-id/upload-id.module").then(
            (m) => m.UploadIdModule
          ),
      },

      {
        path: "shop/product/:CatalogItemId",
        loadChildren: () =>
          import("../pages/shop/product-details/product-details.module").then(
            (m) => m.ProductDetailsModule
          ),
        // resolve: { product: ProductResolver }
      },

      {
        path: "shop",
        loadChildren: () =>
          import("../pages/shop/shop/shop.module").then((m) => m.ShopModule),
      },

      {
        path: "brand",
        loadChildren: () =>
          import("../pages/brands/brands.module").then((m) => m.BrandsModule),
      },
      {
        path: "order",
        loadChildren: () =>
          import("../pages/order/order.module").then((m) => m.OrderModule),
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("../pages/user-dashboard/user-dashboard.module").then(
            (m) => m.UserDashboardModule
          ),
      },
      {
        path: "forgot-password",
        loadChildren: () =>
          import("../pages/forgot-password/forgot-password.module").then(
            (m) => m.ForgotPasswordModule
          ),
      },

      {
        path: "how-to-shop",
        loadChildren: () =>
          import("../pages/howtoorder/howtoorder.module").then(
            (m) => m.HowtoorderModule
          ),
      },

      {
        path: "local-delivery",
        loadChildren: () =>
          import("../pages/local-delivery/local-delivery.module").then(
            (m) => m.LocalDeliveryModule
          ),
      },

      {
        path: "pickup-detail",
        loadChildren: () =>
          import("../pages/pickup-detail/pickup-detail.module").then(
            (m) => m.PickupDetailModule
          ),
      },

      {
        path: "press",
        loadChildren: () =>
          import("../pages/blogs/blogs.module").then((m) => m.BlogsModule),
      },
      {
        path: "weed-delivery/:key",
        loadChildren: () =>
          import("../pages/weed-delivery/weed-delivery.module").then(
            (m) => m.WeedDeliveryModule
          ),
      },

      {
        path: "delivery-area",
        loadChildren: () =>
          import("../pages/delivery-areas/delivery-areas.module").then(
            (m) => m.DeliveryAreasModule
          ),
      },

      {
        path: "sitemap",
        loadChildren: () =>
          import("../pages/site-map/site-map.module").then(
            (m) => m.SiteMapModule
          ),
      },
      {
        path: "cart",
        component: SidenavComponent,
      },
      {
        path: "Cannabis_Delivery_Larchmont_NY",
        component: CannabisDispensaryInLarchmontComponent,
      },

      {
        path: "Disposable_Vapes_Larchmont_NY",
        component: VapeStoreInLarchmontComponent,
      },

      {
        path: "Buy_Weed_Online_in_Rye",
        component: BuyWeedOnlineInRyeComponent,
      },

      {
        path: "Buy_Edibles_Online_Rye",
        component: BuyEdiblesOnlinePoundRidgeComponent,
      },

      {
        path: "Cannabis_Delivery_Mamaroneck_NY",
        component: CannabisDispensaryDeliveryMamaroneckComponent,
      },
      {
        path: "Buy_Pre_Rolls_Online_in_Rye_NY",
        component: BuyPreRollsOnlineRyeComponent,
      },



      {
        path: "Vape_Pen_Cartridges_Mamaroneck_NY",
        component: BestVapeDeliveryServiceMamaroneckNYComponent,
      },
      {
        path: "Cannabis_Delivery_bronx_NY",
        component: CannabisDispensaryDeliveryBronxComponent,
      },
      {
        path: "Weed_Delivery_Bronx_NY",
        component: OnlineWeedDispensaryBronxComponent,
      },
      {
        path: "Weed_Delivery_Mamaroneck_NY",
        component: WeedDispensaryMamaroneckComponent,
      },
      {
        path: "THC_Drinks_in_Bronx",
        component: THCDrinksInBronxComponent,
      },
      {
        path: "Vape_Pen_Cartridges_Bronx_NY",
        component: VapePenCartridgesShopOnlineInBronxComponent,
      },
    ],
  },
];

//   
@NgModule({
  declarations: [
    StartComponent, 
    HeaderComponent, 
    FooterComponent, 
    onlyFirstWordPipe, 
    SidenavComponent, 
    RegisterComponent,
    AddCreditCardComponent,
    NotFoundComponent,
    ProductListingComponent,
    CannabisDispensaryInLarchmontComponent,
    VapeStoreInLarchmontComponent,
    BuyWeedOnlineInRyeComponent,
    BuyEdiblesOnlinePoundRidgeComponent,
    CannabisDispensaryDeliveryMamaroneckComponent,
    BuyPreRollsOnlineRyeComponent,
    BestVapeDeliveryServiceMamaroneckNYComponent,
    CannabisDispensaryDeliveryBronxComponent,
    OnlineWeedDispensaryBronxComponent,
    WeedDispensaryMamaroneckComponent,
    THCDrinksInBronxComponent,
    VapePenCartridgesShopOnlineInBronxComponent
    
  ],
  imports: [
    CommonModule,
    CarouselModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatChipsModule,
    MatFormFieldModule,
    MatTooltipModule,
    SharedModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxFastMarqueeModule,

  ],
  providers: [CartlengthService],
})
export class StartModule {}
